import React, { useEffect, useState } from 'react';
import { useRouter } from 'next/router';
import Head from 'next/head';
import { isEmpty } from 'lodash';
import PageLayout from '@/components/PageLayout';
import { getLayoutProps } from '@/utils/layout/layout';
import User from '@/store/user';
import styles from '@/styles/Gifts.module.css';
import { WaveCxmContextProvider } from '@desquared/wave-cxm-react';
import QuestionnaireComponent from '@/components/Questionnaire/Questionnaire';
import Cookies from 'universal-cookie';
const cookies = new Cookies();

export default function Questionnaire({ responsiveLogo }) {
  const [user, setUser] = useState();
  const authorization = cookies.get('token');
  const headers = process.env.NEXT_PUBLIC_APPID.split('-');
  const router = useRouter(); // Get the router object

  const { slug } = router.query;
  useEffect(() => {
    const user$ = User.subscribe(_user => {
      setUser(_user);
    });
    return () => user$.unsubscribe();
  }, []);

  return (
    <>
      <Head>
        <title>{process.env.displayName}</title>
        <meta name="description" content={`App for ${process.env.displayName} by Wave Grocery`} />
        <meta name="viewport" content="width=device-width, initial-scale=1" />
        <link rel="icon" href={responsiveLogo} />
      </Head>

      <main className={styles.mainContainer}>
        <div className={styles.giftsWrapper}>
          <QuestionnaireComponent user={user} touchpoint={slug[0]} />
        </div>
      </main>
    </>
  );
}

Questionnaire.getLayout = function getLayout(page) {
  return <PageLayout>{page}</PageLayout>;
};
export async function getStaticPaths({ locales }) {
  const paths = [
    {
      params: { slug: ['ORDER_COMPLETION'] },
    },
    {
      params: { slug: ['ORDER_COMPLETION_EMAIL'] },
    },
    {
      params: { slug: ['ORDER_SUBMISSION'] },
    },
    {
      params: { slug: ['ORDER_STORE_DELIVERY_EMAIL'] },
    },
    {
      params: { slug: ['ORDER_HOME_DELIVERY_EMAIL'] },
    },
    {
      params: { slug: ['PROMO_EMAIL'] },
    },
  ];
  let localizedPaths = [];
  for (const locale of locales) {
    localizedPaths = [...localizedPaths, ...paths.map(path => ({ ...path, locale }))];
  }

  return { paths: localizedPaths, fallback: false };
}

export async function getStaticProps(context) {
  const privateApiKey = process.env.NODE_ENV === 'development' ? process.env.PRIVATE_API_KEY : null;
  const messages = {
    common: (await import(`../../../prebuild-data/i18n/${context.locale}/common.json`)).default,
  };
  try {
    const [layoutProps] = await Promise.all([getLayoutProps({ headerProps: { selectedIndex: 0 } }, context.locale)]);
    return {
      props: {
        ...layoutProps,
        messages,
      },
    };
  } catch (error) {
    console.error(`>>> getStaticProps error: ${error}`);
    return {
      props: {
        error: true,
      },
    };
  }
}
